var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"quality-recommend"},[_c('GoodList',{attrs:{"good-list":_vm.goodsList,"is-sort":false}}),_c('Loading',{attrs:{"loadend":_vm.loadend,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }